import dispatch from './dispatch';

export const trackUpdateBasketItemQuantityEvent = ({
  cartID,
  currencyCode,
  grandTotal,
  eventAction = 'Add to Basket',
  eventName = 'AddtoBasket',
  sumQty,
  total,
  index,
  quantity,
  basePrice,
  productName,
  sku,
  unitPrice,
  displayName,
  url,
  name,
  color,
  type,
  category,
}) => {
  const detail = {
    eventInfo: {
      eventAction,
      eventName,
      eventType: 'userEvent',
      currencyCode,
      cartSummary: {
        grandTotal,
        sumQty,
        cartIndex: `${index + 1} of ${total}`,
        subcartID: `${cartID}_${index + 1}`,
      },
      cartItem: {
        quantity,
        basePrice,
        productInfo: {
          productName,
          sku,
          list: 'cart',
          unitPrice,
          variants: {
            color,
            size: 'N/A',
            type,
          },
          category,
        },
      },
      retailer: {
        displayName,
        index: index + 1,
        url,
        name,
        total,
      },
    },
  };

  dispatch({
    eventName,
    detail,
  });
};

export const trackCartViewEvent = ({
  cartID,
  currencyCode,
  retailer,
  retailerURL,
  grandTotal,
  sumQty,
  cartIndex,
  cartItem,
  total,
}) => {
  const eventName = 'CartView';

  const detail = {
    eventInfo: {
      eventAction: 'Cart View',
      eventName: 'CartView',
      eventType: 'userEvent',
      currencyCode,
      retailer,
      retailerURL,
      cartSummary: {
        grandTotal,
        sumQty,
        cartIndex: `${cartIndex + 1} of ${total}`,
        subcartID: `${cartID}_${cartIndex + 1}`,
      },
      cartItem,
    },
  };

  dispatch({
    eventName,
    detail,
  });
};

export const trackBuyFromRetailerEvent = ({
  cartID,
  currencyCode,
  grandTotal,
  sumQty,
  cartIndex,
  cartItem,
  total,
  displayName,
  url,
  name,
}) => {
  const eventName = 'BuyfromRetailer';

  const detail = {
    eventInfo: {
      eventAction: 'Buy Now from Retailer',
      eventName: 'BuyfromRetailer',
      eventType: 'userEvent',
      currencyCode,
      cartSummary: {
        grandTotal,
        sumQty,
        cartIndex: `${cartIndex + 1} of ${total}`,
        subcartID: `${cartID}_${cartIndex + 1}`,
      },
      cartItem,
      retailer: {
        displayName,
        index: cartIndex + 1,
        url,
        name,
        total,
      },
    },
  };

  dispatch({
    eventName,
    detail,
  });
};

